module.exports = __webpack_public_path__ + "files/5a2a33b6222838b2a87226635bf9758a.png";